export var TimeZone;
(function (TimeZone) {
    TimeZone["kalt"] = "kalt";
    TimeZone["msk"] = "msk";
    TimeZone["samt"] = "samt";
    TimeZone["yekt"] = "yekt";
    TimeZone["omst"] = "omst";
    TimeZone["krat"] = "krat";
    TimeZone["irkt"] = "irkt";
    TimeZone["yakt"] = "yakt";
    TimeZone["vlat"] = "vlat";
    TimeZone["magt"] = "magt";
    TimeZone["pett"] = "pett";
})(TimeZone || (TimeZone = {}));
export const TimeZoneOffsetMapping = {
    [TimeZone.kalt]: -1,
    [TimeZone.msk]: 0,
    [TimeZone.samt]: 1,
    [TimeZone.yekt]: 2,
    [TimeZone.omst]: 3,
    [TimeZone.krat]: 4,
    [TimeZone.irkt]: 5,
    [TimeZone.yakt]: 6,
    [TimeZone.vlat]: 7,
    [TimeZone.magt]: 8,
    [TimeZone.pett]: 9,
};
//# sourceMappingURL=time-zones.js.map